// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3LJ3B","header":"PatientQuestionnaire_header__1a8nt","info":"PatientQuestionnaire_info__yctkc"};